import React, { useEffect, useState } from "react";
import { Col, Form, ProgressBar } from "react-bootstrap";
import api from "common/api";
import { toast } from "react-toastify";

type Props = {
  userId: string;
  initialImageUrl: string | null;
};

const InstructorPictureUpload: React.FC<Props> = ({
  userId,
  initialImageUrl,
}) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  useEffect(() => {
    if (initialImageUrl) {
      setPreviewUrl(initialImageUrl);
    }
  }, [initialImageUrl]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setPreviewUrl(URL.createObjectURL(file));
      uploadImage(file);
    }
  };

  const uploadImage = async (file: File) => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append("picture", file);

    try {
      const response = await api.post(
        `/teachers/${userId}/picture/`,
        formData,
        {
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              setUploadProgress(percentCompleted);
            }
          },
        },
      );

      const uploadedImageUrl = response.data.picture;
      setPreviewUrl(uploadedImageUrl);

      toast.success("Slika je uspješno učitana.");
    } catch (error) {
      console.error("Error uploading image: ", error);
      toast.error("Greška prilikom učitavanja slike.");
      setPreviewUrl(null);
    }

    setIsUploading(false);
  };

  return (
    <>
      <Form.Group as={Col} controlId="formPicture" className="mb-3">
        <Form.Label>Slika</Form.Label>
        <Form.Control
          type="file"
          name="picture"
          onChange={handleFileChange}
          disabled={isUploading}
          className="mb-2"
        />

        {isUploading && (
          <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} />
        )}
      </Form.Group>
      {previewUrl && (
        <img
          src={previewUrl}
          alt="Preview"
          style={{ width: "250px", height: "auto", borderRadius: "10px" }}
          className="mb-3"
        />
      )}
    </>
  );
};

export default InstructorPictureUpload;
